var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349,444s80.18-66.18,99.14-169.36S389.44,150.73,343.89,115.79,281.6,41.52,215.58,39.14s-100.18,24.21-124,75.71-36.62,104.37-44.14,156-3.85,92.82,38.51,113.35,62,11.51,82.16,35.17S280,496.54,349,444Z",
    style: {
      fill: "#25B09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,444s80.18-66.18,99.14-169.36S389.44,150.73,343.89,115.79,281.6,41.52,215.58,39.14s-100.18,24.21-124,75.71-36.62,104.37-44.14,156-3.85,92.82,38.51,113.35,62,11.51,82.16,35.17S280,496.54,349,444Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-3--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.64,464.87s-5.86-50.45-5.28-54.57,6.26-28.23,8.64-33.55a122.93,122.93,0,0,0,7.83-26.42c1.47-9.39,1-12,1.32-13.11s.62-20.53-.75-26.43-4.8-16.58-4.8-16.58-.44-10.42-8.87-24.6-8.44-14.55-13.44-18.07-9.94-5.92-14.81-6.46-9.28.77-7.51,7.4,9.11,12.67,9.11,12.67,4.85,9.11,6.86,12.38a60.56,60.56,0,0,1,3.66,7.3l.42,10.05L351.93,301a33.45,33.45,0,0,1-6.77-10.15c-2.1-5.5-10.09-.69-12.71,8s-40.67,34.53-39,47.51,2.63,44.62,8.84,59.27,7.81,17.19,7.81,17.19l-1,47.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.13,471h0a.52.52,0,0,1-.5-.51l1-47.62c-.39-.67-2.28-4.17-7.77-17.12-4.66-11-6.39-31.54-7.65-46.52-.43-5.16-.8-9.61-1.23-12.89-1-8.09,12.28-20.47,24-31.4,7.19-6.68,14-13,15-16.31,1.94-6.45,6.68-10.57,9.95-10.69a3.74,3.74,0,0,1,3.71,2.66,32.58,32.58,0,0,0,6.17,9.48l2.72-5.35-.42-9.83a60.09,60.09,0,0,0-3.59-7.15c-1.88-3.07-6.33-11.38-6.83-12.32-.84-.71-7.48-6.44-9.2-12.86-.73-2.74-.49-4.84.71-6.23,1.34-1.56,3.88-2.18,7.35-1.8,4.59.51,9.51,2.65,15,6.55,4.76,3.35,5.17,4,12,15.6l1.56,2.63c8,13.52,8.88,23.81,8.94,24.76.28.88,3.49,10.92,4.79,16.55,1.4,6,1.11,25.4.74,26.69a8.06,8.06,0,0,0-.14,1.7,86.41,86.41,0,0,1-1.16,11.34A123.76,123.76,0,0,1,376.46,377c-2.32,5.16-8,29.32-8.61,33.41s5.23,53.94,5.29,54.45a.5.5,0,1,1-1,.11c-.24-2.06-5.86-50.56-5.29-54.7s6.27-28.29,8.69-33.68a123.37,123.37,0,0,0,7.79-26.3A85.93,85.93,0,0,0,384.49,339a8.3,8.3,0,0,1,.18-1.93c.28-1,.58-20.42-.76-26.19s-4.75-16.43-4.78-16.53a.35.35,0,0,1,0-.13c0-.11-.54-10.48-8.8-24.37l-1.56-2.63c-6.89-11.62-7.15-12.07-11.73-15.29-5.39-3.8-10.16-5.88-14.58-6.37-2.18-.24-5.07-.19-6.48,1.45-1,1.13-1.14,2.92-.5,5.32,1.71,6.4,8.87,12.35,8.94,12.41a.47.47,0,0,1,.13.15c0,.09,4.87,9.14,6.84,12.36a60.79,60.79,0,0,1,3.7,7.37.47.47,0,0,1,0,.17l.42,10.05a.45.45,0,0,1,0,.25l-3.1,6.09a.52.52,0,0,1-.36.27.55.55,0,0,1-.44-.14A33.69,33.69,0,0,1,344.69,291a2.67,2.67,0,0,0-2.74-2c-2.92.11-7.21,3.95-9,10-1.08,3.57-7.65,9.68-15.26,16.76-11,10.22-24.7,22.95-23.72,30.53.42,3.31.79,7.77,1.23,12.93,1.25,14.92,3,35.36,7.57,46.21,6.09,14.37,7.76,17.1,7.77,17.13a.5.5,0,0,1,.08.27l-1,47.76A.49.49,0,0,1,309.13,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.75,351.88s3.3,12.4,9.8,16.4S318.8,370,318.8,370l7.26,4.5,28.25-37.76s6-18.25,5.5-24.75-1-10.5-2-11.25-8.25-3.76-8.25-3.76l-2.75-3.25-3.44-6.42A57,57,0,0,1,330.31,309c-9.51,9.5-28.26,23.5-32,31.25S293.5,346.38,294.75,351.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.05,375a.48.48,0,0,1-.26-.07l-7.07-4.39c-1.34.35-8.35,1.88-14.43-1.86-6.6-4.06-9.89-16.19-10-16.7v0c-.88-3.88-.65-4.42.89-7a54.16,54.16,0,0,0,2.7-4.94c2.51-5.19,11.43-13,20.07-20.49,4.52-3.94,8.79-7.66,12-10.91a57,57,0,0,0,12.94-21.46.52.52,0,0,1,.43-.36.5.5,0,0,1,.49.26l3.42,6.38,2.63,3.12a87.94,87.94,0,0,1,8.25,3.77c1.05.78,1.59,3.6,2.2,11.61.5,6.53-5.28,24.2-5.52,24.95a.64.64,0,0,1-.08.14l-28.25,37.76A.51.51,0,0,1,326.05,375Zm-7.25-5.5a.5.5,0,0,1,.27.08l6.86,4.26,27.93-37.33c.43-1.3,5.93-18.37,5.46-24.48-.26-3.29-.78-10.13-1.81-10.89a83.57,83.57,0,0,0-8.14-3.69.52.52,0,0,1-.19-.14l-2.75-3.25-.06-.09-2.89-5.4a58,58,0,0,1-12.82,20.77c-3.27,3.27-7.55,7-12.09,10.95-8.55,7.46-17.4,15.17-19.82,20.17-1.17,2.42-2.08,3.93-2.74,5-1.44,2.39-1.59,2.65-.78,6.24.11.38,3.4,12.29,9.58,16.1s13.78,1.71,13.86,1.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.86,265.88a10.87,10.87,0,0,1-4.43-.88.5.5,0,0,1,.44-.9c.22.11,5.49,2.57,11.44-1.85a.51.51,0,0,1,.7.11.5.5,0,0,1-.1.7A13.38,13.38,0,0,1,349.86,265.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,329.09,335,341.49a.9.9,0,0,1-1.58-.67l1.52-16,54.47-131.64a1.86,1.86,0,0,1,2.42-1l6.92,2.87a1.84,1.84,0,0,1,1,2.42Z",
    style: {
      fill: "#25B09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.35,342.32a1.43,1.43,0,0,1-1.4-1.55l1.52-16a.74.74,0,0,1,0-.14L389,193a2.36,2.36,0,0,1,3.07-1.28l6.92,2.86a2.37,2.37,0,0,1,1.28,3.08L345.77,329.28a.33.33,0,0,1-.07.13l-10.29,12.4A1.37,1.37,0,0,1,334.35,342.32Zm1.11-17.39L334,340.87a.38.38,0,0,0,.24.41.37.37,0,0,0,.45-.11l10.24-12.34,54.44-131.58a1.34,1.34,0,0,0-.73-1.76l-6.92-2.86a1.34,1.34,0,0,0-1.76.73Zm9.85,4.16h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.53,212.56l6.25-15.11a1.84,1.84,0,0,0-1-2.42l-6.92-2.87a1.86,1.86,0,0,0-2.42,1l-6.25,15.11Z",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.53,213.06a.58.58,0,0,1-.19,0L383,208.75a.5.5,0,0,1-.27-.66L389,193a2.34,2.34,0,0,1,3.07-1.28l6.92,2.86a2.37,2.37,0,0,1,1.28,3.08L394,212.75a.53.53,0,0,1-.27.28A.63.63,0,0,1,393.53,213.06ZM383.84,208l9.42,3.9,6.06-14.66a1.34,1.34,0,0,0-.73-1.76l-6.92-2.86a1.32,1.32,0,0,0-1,0,1.25,1.25,0,0,0-.73.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.12,
    y: 201.49,
    width: 7.23,
    height: 11.19,
    transform: "translate(49.38 488.03) rotate(-67.52)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.53,213.06a.58.58,0,0,1-.19,0L383,208.75a.51.51,0,0,1-.27-.27.53.53,0,0,1,0-.39l2.76-6.68a.51.51,0,0,1,.66-.27l10.34,4.28a.51.51,0,0,1,.27.27.5.5,0,0,1,0,.38L394,212.75A.49.49,0,0,1,393.53,213.06ZM383.84,208l9.42,3.9,2.38-5.76-9.42-3.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,324.85l-1.52,16a.9.9,0,0,0,1.58.67l10.26-12.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.35,342.32a1.43,1.43,0,0,1-1.4-1.55l1.52-16a.49.49,0,0,1,.24-.38.51.51,0,0,1,.45,0l10.32,4.27a.5.5,0,0,1,.3.35.51.51,0,0,1-.11.44l-10.26,12.37A1.37,1.37,0,0,1,334.35,342.32Zm1-16.75L334,340.87a.38.38,0,0,0,.24.41.37.37,0,0,0,.45-.11l9.83-11.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.12,333.78l-.67,7a.9.9,0,0,0,1.58.67l4.52-5.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.35,342.32a1.43,1.43,0,0,1-1.4-1.55l.67-7a.56.56,0,0,1,.24-.39.51.51,0,0,1,.45,0l5.44,2.25a.52.52,0,0,1,.29.34.49.49,0,0,1-.1.44l-4.53,5.46A1.37,1.37,0,0,1,334.35,342.32Zm.2-7.82-.6,6.37a.38.38,0,0,0,.24.41.37.37,0,0,0,.45-.11l4.1-4.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.29,360.34a6.8,6.8,0,0,1-.8,3,8.89,8.89,0,0,1-7.23,4.24c-3.7.16-9.64-3.3-13.77-8s-5.35-11.58-7.18-16.37-2-9.4,1.43-15.57,10.95-3.94,10.95-3.94,5.37,17.61,7.65,22.14S320.29,360.34,320.29,360.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,368.13c-3.84,0-9.76-3.46-13.91-8.16-3.13-3.56-4.61-8.3-5.92-12.48-.45-1.45-.88-2.82-1.34-4.05-2.13-5.58-1.69-10.36,1.45-16,3.6-6.44,11.45-4.19,11.53-4.17a.52.52,0,0,1,.34.34c.05.17,5.39,17.61,7.62,22.06s8.84,14.29,8.91,14.39a.54.54,0,0,1,.09.25,7.22,7.22,0,0,1-.86,3.3,9.38,9.38,0,0,1-7.65,4.51Zm-11.47-44.29a8,8,0,0,0-7.37,4.09c-3,5.42-3.44,9.81-1.4,15.16.48,1.25.91,2.64,1.37,4.1,1.28,4.09,2.72,8.72,5.71,12.11,4,4.51,9.57,7.83,13.14,7.83h.24a8.42,8.42,0,0,0,6.8-4,6.61,6.61,0,0,0,.75-2.66c-.83-1.23-6.75-10.09-8.9-14.37s-6.89-19.65-7.6-21.95A11.33,11.33,0,0,0,300.55,323.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.72,366.65a.51.51,0,0,1-.42-.23c-2.12-3.28-1.71-3.9-1.58-4.11a.74.74,0,0,1,.77-.3c1,.16,4.57-.19,6-1.33,1.65-1.29,1.92-1.42,3.36-.36a29.15,29.15,0,0,1,3,2.71.5.5,0,0,1,0,.71.49.49,0,0,1-.7,0,28.8,28.8,0,0,0-2.83-2.59c-.89-.66-.89-.66-2.16.34-1.6,1.24-5,1.65-6.5,1.56a15.18,15.18,0,0,0,1.5,2.85.5.5,0,0,1-.15.69A.53.53,0,0,1,308.72,366.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.42,356.46a.48.48,0,0,1-.41-.23.49.49,0,0,1,.06-.62l3.13-3.15a.5.5,0,0,1,.71.71l-1.37,1.37a40.47,40.47,0,0,0,4.26-2,.5.5,0,0,1,.69.15.49.49,0,0,1-.16.69,61.87,61.87,0,0,1-6.72,3.08A.41.41,0,0,1,301.42,356.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.56,303s-6.18-3.68-11.7,2.58-4.82,12-1.83,22.54,6.39,19.64,8.58,22.33S320.1,361.5,325,361.3c0,0,8.22-2.67,9.64-7.36s-1.19-6.43-1.19-6.43l-3.51-6.34-1.37-5s-4.63-10.92-6-16.65S318.56,303,318.56,303Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.78,361.8c-4,0-7.39-5-9.87-8.69-.66-1-1.22-1.8-1.68-2.37-2.16-2.63-5.48-11.26-8.68-22.51s-3.59-16.76,1.93-23c5.73-6.49,12.27-2.72,12.33-2.68a.48.48,0,0,1,.23.31c0,.11,2.56,10.84,3.94,16.51s6,16.46,6,16.57l1.37,5,3.43,6.19c.53.41,2.66,2.42,1.29,6.92-1.48,4.88-9.62,7.57-10,7.68a.61.61,0,0,1-.13,0Zm-10.54-59.41a9.16,9.16,0,0,0-7,3.5c-5.21,5.89-4.77,11.33-1.72,22.07,3.12,11,6.45,19.65,8.49,22.15.49.6,1.07,1.45,1.74,2.44,2.24,3.32,5.64,8.29,9.13,8.25.76-.26,8-2.83,9.26-7s-.91-5.8-1-5.87a.44.44,0,0,1-.16-.17l-3.51-6.34a.37.37,0,0,1,0-.11l-1.37-5s-4.64-11-6-16.67c-1.27-5.22-3.52-14.73-3.89-16.29A8.73,8.73,0,0,0,314.24,302.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,346.21a.5.5,0,0,1-.49-.39.51.51,0,0,1,.39-.6,31.64,31.64,0,0,0,5.27-2.43.5.5,0,0,1,.68.2.51.51,0,0,1-.19.68,34.32,34.32,0,0,1-5.56,2.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.49,345.08a.59.59,0,0,1-.26-.07.52.52,0,0,1-.17-.69c1-1.68,4.8-2.59,5.23-2.69a.48.48,0,0,1,.6.37.5.5,0,0,1-.37.6c-1,.24-3.92,1.12-4.6,2.24A.51.51,0,0,1,315.49,345.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.92,359.28a2.74,2.74,0,0,1-1.78-.56,2.35,2.35,0,0,1-.73-2c.14-2.91,6.35-3.48,7-3.53a.48.48,0,0,1,.54.45.5.5,0,0,1-.46.54c-1.56.12-6,.86-6.13,2.59a1.41,1.41,0,0,0,.38,1.18,2.24,2.24,0,0,0,1.65.27.5.5,0,0,1,.59.39.49.49,0,0,1-.38.59A3.41,3.41,0,0,1,324.92,359.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.38,298.46a21.57,21.57,0,0,0,0-11.12c-1.64-5.95-5-8.82-8.93-8.65s-10.19,0-12.89,7.49-2.8,15.86-3,22.36,1.23,12.68,2.72,14.93,10.18,16.25,11.17,17.83,4.48,1.89,8.34.11,6.24-5.83,6.11-8.83S342,315,342,315a23,23,0,0,0,1.15-5.61A84.86,84.86,0,0,0,343.38,298.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.8,343.12c-1.74,0-3.12-.52-3.77-1.56-.24-.37-.91-1.44-1.81-2.89-2.88-4.62-8.23-13.21-9.36-14.92-1.53-2.32-3-8.65-2.8-15.23l0-.95c.18-6.38.4-14.32,3-21.56,2.66-7.44,8.69-7.65,12.68-7.8l.66,0c4.35-.19,7.8,3.1,9.43,9a22,22,0,0,1,0,11.31,83.73,83.73,0,0,1-.24,10.89,26.85,26.85,0,0,1-1.12,5.56c.56,1.73,4.76,14.69,4.88,17.59.13,3.06-2.23,7.37-6.4,9.3A12.64,12.64,0,0,1,335.8,343.12Zm-1.05-63.94h-.29l-.66,0c-3.94.14-9.34.34-11.78,7.14-2.53,7.08-2.75,14.94-2.93,21.25l0,.95c-.18,6.39,1.19,12.46,2.63,14.65,1.14,1.72,6.5,10.32,9.38,14.94l1.8,2.89c.82,1.3,4,1.64,7.71-.08s5.94-5.62,5.82-8.35c-.12-2.9-4.84-17.34-4.89-17.49a.56.56,0,0,1,0-.36,22.57,22.57,0,0,0,1.12-5.46,86.8,86.8,0,0,0,.23-10.81.32.32,0,0,1,0-.17,21.18,21.18,0,0,0,0-10.84C341.43,282.18,338.48,279.18,334.75,279.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,337.84a.51.51,0,0,1-.44-.26c-1.54-2.77-6.26-9.62-9.64-7.93-4.1,2.06-3.21,5.67-3.17,5.83a.5.5,0,1,1-1,.25,6.22,6.22,0,0,1,3.7-7c4.91-2.46,10.71,7.9,11,8.34a.51.51,0,0,1-.2.68A.5.5,0,0,1,343.86,337.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.57,318.09a.59.59,0,0,1-.25-.07.51.51,0,0,1-.18-.69,9.76,9.76,0,0,1,5.08-3.83.5.5,0,0,1,.36.94,8.71,8.71,0,0,0-4.57,3.4A.51.51,0,0,1,323.57,318.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,313.67a.5.5,0,0,1-.12-1,17.9,17.9,0,0,1,2.19-.4.5.5,0,0,1,.1,1,19.5,19.5,0,0,0-2,.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.59,318.19a.5.5,0,0,1-.16-1,31.6,31.6,0,0,0,5.56-2.5.5.5,0,0,1,.56.83,30.51,30.51,0,0,1-5.8,2.61A.45.45,0,0,1,326.59,318.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.24,392.06s2.16-20,7.82-34.14,13.49-20.48,16.17-22.91a66.76,66.76,0,0,0,5.75-6.27l4.5-8.75s.54-14.62.35-19,.81-13.69,6.83-24.6,10.39-11.79,13.13-12.83,8.6.8,10.31,3-6,18.08-5.72,23.4-1.39,16.5-1.9,26.48.13,15-1.59,30.49-3.52,28.89-3.52,28.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.24,392.56h-.06a.5.5,0,0,1-.44-.55c0-.2,2.24-20.24,7.85-34.27,5.33-13.33,12.61-19.81,15.72-22.58l.58-.52a66.4,66.4,0,0,0,5.67-6.17l4.42-8.61c0-1.36.53-14.74.35-18.86-.11-2.69.05-12.46,6.9-24.86,5.67-10.27,9.93-11.81,12.75-12.83l.63-.23c2.87-1.09,9,.7,10.89,3.21,1,1.32-.28,5.31-2.47,11.73-1.6,4.68-3.26,9.51-3.15,12a122.78,122.78,0,0,1-.85,13.38c-.39,4.12-.83,8.8-1,13.14-.16,3.25-.21,6-.25,8.7A201.4,201.4,0,0,1,376.39,347c-1.7,15.31-3.51,28.78-3.53,28.91a.5.5,0,0,1-.56.43.51.51,0,0,1-.43-.56c0-.14,1.83-13.59,3.52-28.89a199.48,199.48,0,0,0,1.34-21.73c0-2.69.09-5.47.26-8.73.22-4.36.66-9.05,1.05-13.18a123.27,123.27,0,0,0,.84-13.25c-.11-2.62,1.57-7.55,3.2-12.32,1.5-4.38,3.36-9.83,2.63-10.8-1.64-2.14-7.29-3.8-9.75-2.87l-.64.23c-2.68,1-6.73,2.43-12.22,12.37-6.72,12.18-6.88,21.71-6.77,24.34.18,4.36-.35,18.9-.35,19a.65.65,0,0,1-.06.21L350.43,329l-.06.09a65.61,65.61,0,0,1-5.81,6.32l-.59.53c-3.05,2.72-10.2,9.09-15.45,22.2-5.56,13.91-7.76,33.81-7.79,34A.49.49,0,0,1,320.24,392.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.05,283.36c-1.94,0-4.91-1-6.23-2.84-1.87-2.56,2.38-12.64,3.69-14.3,1.56-2,6.6-1.54,7.16-1.48a.5.5,0,0,1,.45.55.49.49,0,0,1-.54.45c-1.4-.14-5.25-.22-6.28,1.1-1.43,1.81-5,11.22-3.67,13.09,1.47,2,5.29,2.74,6.26,2.31a.5.5,0,0,1,.66.25.49.49,0,0,1-.25.66A3.16,3.16,0,0,1,378.05,283.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.23,298.83a.5.5,0,0,1-.22-.95c1.84-.88,6.11-.33,6.3-.3a.5.5,0,0,1,.42.56.5.5,0,0,1-.56.43c-1.15-.15-4.42-.41-5.72.21A.59.59,0,0,1,371.23,298.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.83,301.41a13.13,13.13,0,0,1-5-1,.5.5,0,1,1,.4-.91,11.76,11.76,0,0,0,6.73.68.5.5,0,1,1,.25,1A9.52,9.52,0,0,1,373.83,301.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,307.7c-3.58,0-4.7-2.12-4.76-2.23a.51.51,0,0,1,.22-.67.5.5,0,0,1,.67.22c.06.1,1.31,2.35,5.81,1.48a.48.48,0,0,1,.58.39.5.5,0,0,1-.39.59A11.49,11.49,0,0,1,372.07,307.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-2--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.91,106.13s-56.46-6.83-63.65-9.65S234,59.58,230,58s-10.31,0-12.5,1.25S205,64,200,66.46s-30,12.51-35,15.32A15.49,15.49,0,0,0,157.42,93c-.31,3.12-7.19,27.82-5.94,32.83s3.43,21.26,5.31,25.64,4.07,3.44,6.25,3.13,9.39-4.07,9.39-4.07,2.81,10.63,5.94,15.64,6.87,13.44,10.63,13.44,6.88-3.44,6.88-3.44,19.69,6.88,24.7,7.82,8.44,0,9.69-2.19-.31-7.5-.31-7.5,15,0,14.38-7.19-4.06-9.7-6.25-10.63-8.76-1.88-8.76-1.88h14.39s12.19,3.75,27.2,9.69,27.83,7.82,45,5S336,164,339.09,164s106.42,23.31,106.42,23.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.51,187.84l-.11,0c-35.71-8-103.88-23.29-106.31-23.29h0a14,14,0,0,0-4.09.94,121.88,121.88,0,0,1-19,4.36c-16.37,2.68-29.5,1.22-45.29-5-14.23-5.63-26.07-9.34-27.1-9.66H235a20.43,20.43,0,0,1,3.26.92c2.65,1.13,5.94,4,6.55,11a4.77,4.77,0,0,1-1.31,3.81c-3.07,3.35-10.64,3.84-12.92,3.92.38,1.51,1.18,5.36.09,7.26-1.42,2.5-5.15,3.39-10.22,2.43-4.7-.88-21.88-6.83-24.47-7.73-.81.81-3.64,3.36-7,3.36s-6.14-5.12-8.95-10.08c-.74-1.3-1.44-2.52-2.11-3.6-2.74-4.38-5.19-12.83-5.83-15.17-1.75.89-7.09,3.56-9,3.83l-.68.11c-2,.35-4.27.74-6.1-3.53-1.21-2.82-2.5-10.26-3.65-16.81-.63-3.65-1.23-7.09-1.69-8.91-.91-3.64,2.24-16.93,4.33-25.71.84-3.58,1.51-6.4,1.6-7.29a16.05,16.05,0,0,1,7.76-11.65c2.89-1.62,12.41-5.63,20.81-9.17,6.23-2.62,12.11-5.1,14.23-6.16,2.75-1.37,7-3,10.78-4.43,3.08-1.18,5.75-2.2,6.71-2.75,2.28-1.3,8.74-2.89,12.93-1.28,1.8.69,15,7.47,30.28,15.32,19.68,10.11,42,21.57,46,23.15,7.05,2.76,63,9.55,63.53,9.61a.52.52,0,0,1,.44.56.5.5,0,0,1-.56.44c-2.31-.28-56.6-6.88-63.77-9.68C302,95.35,279.66,83.88,260,73.76c-14.62-7.51-28.43-14.6-30.17-15.27-3.91-1.51-9.94,0-12.08,1.21a73.65,73.65,0,0,1-6.86,2.81c-3.74,1.43-8,3.05-10.68,4.4-2.15,1.07-8,3.56-14.29,6.18-8.38,3.53-17.87,7.53-20.71,9.12a15.06,15.06,0,0,0-7.25,10.88c-.1,1-.74,3.66-1.63,7.42-1.94,8.16-5.18,21.83-4.33,25.24.47,1.85,1,5.16,1.71,9,1.08,6.18,2.42,13.87,3.58,16.58,1.52,3.55,3.06,3.29,5,2.95l.71-.12c2.08-.3,9.15-4,9.22-4a.52.52,0,0,1,.44,0,.51.51,0,0,1,.28.33c0,.11,2.83,10.62,5.88,15.5.68,1.09,1.38,2.33,2.13,3.64,2.42,4.26,5.43,9.57,8.08,9.57,3.49,0,6.48-3.24,6.51-3.27a.5.5,0,0,1,.53-.14c.2.07,19.72,6.88,24.63,7.8,4.55.85,8,.13,9.17-1.95.94-1.64.06-5.69-.36-7.11a.47.47,0,0,1,.08-.44.48.48,0,0,1,.4-.2c.09,0,9.57-.05,12.84-3.61a3.78,3.78,0,0,0,1-3c-.57-6.58-3.55-9.19-6-10.21-2.1-.91-8.56-1.84-8.63-1.85a.5.5,0,0,1,.07-1h14.39l.14,0c.13,0,12.39,3.83,27.25,9.71,15.82,6.26,28.37,7.66,44.76,5a120.07,120.07,0,0,0,18.82-4.34,15,15,0,0,1,4.4-1h0c3.14,0,102.31,22.37,106.54,23.32a.5.5,0,0,1-.12,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.86,161.28l.16.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,161.86a.46.46,0,0,1-.2-.05l-.1,0,.14-.49.21-.45-.21.45.21-.45-.21.45.28-.42.09,0a.5.5,0,0,1-.21,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.82,161.27h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.85,161.78h-.07l-.12,0a.52.52,0,0,1-.28-.66.48.48,0,0,1,.64-.27h0l-.2.46.2-.46h0a.51.51,0,0,1,.26.66.5.5,0,0,1-.42.3h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.72,161.22h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.73,161.73a.65.65,0,0,1-.19,0l.37-.93h0a.51.51,0,0,1,.26.66A.53.53,0,0,1,214.73,161.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,161.36l.33.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.34,162a.48.48,0,0,1-.2,0h0l-.32-.15a.49.49,0,0,1-.25-.66.5.5,0,0,1,.66-.25l.32.15a.5.5,0,0,1,.25.66A.49.49,0,0,1,215.34,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.74,161.23l.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.61,161.72h0a.55.55,0,0,1-.29-.68.47.47,0,0,1,.62-.27l-.2.46.21-.46-.21.46.23-.45h0l-.15.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.35,161.5l.58.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.93,162.27a.52.52,0,0,1-.21,0h0l-.58-.27a.5.5,0,0,1,.41-.91l.59.27a.5.5,0,0,1,.25.66A.52.52,0,0,1,215.93,162.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.11,162.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,162.86a.78.78,0,0,1-.22,0h0l-.12-.06h0a.5.5,0,0,1,.41-.91h0l.1,0h0a.49.49,0,0,1,.29.41.5.5,0,0,1-.2.45A.46.46,0,0,1,217.25,162.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.91,162.21l.2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,162.81a.45.45,0,0,1-.19-.05l-.14-.06h0l-.07,0h0a.53.53,0,0,1-.21-.64.46.46,0,0,1,.62-.26h0l.16.08h0a.52.52,0,0,1,.23.66A.51.51,0,0,1,217.1,162.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.74,162.14l.17.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,162.71a.43.43,0,0,1-.19,0l-.17-.08a.5.5,0,0,1-.25-.66.52.52,0,0,1,.67-.25l.16.08h0a.52.52,0,0,1,.21.64A.48.48,0,0,1,216.89,162.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.93,161.77l.37.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3,162.44a.45.45,0,0,1-.2,0h0l-.37-.17a.5.5,0,0,1-.24-.67.49.49,0,0,1,.66-.24l.37.16a.5.5,0,0,1-.21,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3,161.94l.44.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.74,162.64a.54.54,0,0,1-.21,0l-.44-.19a.51.51,0,0,1,.42-.92l.43.2a.5.5,0,0,1-.2,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66,149.33a29.52,29.52,0,0,0-9-.58c-.57-2-3.54-4.06-4.6-4.81-1.8-1.29-31.47,2.83-35.59,5.93s-8,6.19-6.45,11.35l5.67,3.35s10.32-5.93,16-3.35c0,0,5.15-5.68,10.83-6.71l18.17.13s12.81,3.55,18.72,6.26,18.2-3,19.92-4.43S257.52,151.3,248.66,149.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.72,165.07a.45.45,0,0,1-.25-.07l-5.68-3.35a.46.46,0,0,1-.22-.29c-1.7-5.65,2.73-9,6.63-11.89,4.23-3.18,34.18-7.38,36.18-5.94l.12.08c1.14.81,3.72,2.65,4.53,4.61a29.85,29.85,0,0,1,8.74.63h0c2.94.65,7.84,1.49,13,2.39,15.83,2.72,20.81,3.76,21.13,4.91a.69.69,0,0,1-.23.7c-1.6,1.36-14.25,7.35-20.46,4.5-5.59-2.56-17.6-5.94-18.58-6.21l-18.1-.13c-5.35,1-10.41,6.49-10.46,6.55a.5.5,0,0,1-.58.11C209.13,159.23,199.07,165,199,165A.54.54,0,0,1,198.72,165.07Zm-5.25-4.18,5.26,3.11c1.64-.91,10.42-5.5,15.86-3.38,1.11-1.15,5.73-5.67,10.87-6.6l18.26.12.13,0c.13,0,12.92,3.59,18.79,6.28,5.32,2.44,16.53-2.37,19.08-4.11-2-1-12.38-2.78-20.1-4.11-5.2-.89-10.11-1.74-13.07-2.4h0a28.72,28.72,0,0,0-8.82-.57.5.5,0,0,1-.52-.36c-.5-1.77-3.26-3.73-4.3-4.47l-.11-.08c-1.63-.93-30.67,2.68-35,5.93C195.31,153.63,192.22,156.38,193.47,160.89ZM282,156.51h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.88,176.72a.48.48,0,0,1-.4-.21.5.5,0,0,1,.1-.7c4.85-3.55,1.68-15.21,1.64-15.33a.51.51,0,0,1,.35-.62.52.52,0,0,1,.62.35c.14.51,3.38,12.45-2,16.41A.45.45,0,0,1,195.88,176.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,178a.51.51,0,0,1-.5-.42,21,21,0,0,1,0-5.81c.41-2.47-2.59-6.36-2.62-6.4a.5.5,0,0,1,.79-.61c.13.17,3.29,4.27,2.81,7.17a20.57,20.57,0,0,0,0,5.49.49.49,0,0,1-.42.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.58,184.14a.49.49,0,0,1-.45-.28,16.5,16.5,0,0,1-1.46-8.44c-1.91-.5-9.92-2.53-13.18-2.14a1.66,1.66,0,0,0-1.37.79c-.69,1.25.22,3.75.63,4.6a.5.5,0,0,1-.24.67.5.5,0,0,1-.66-.24c-.07-.14-1.69-3.55-.61-5.51a2.59,2.59,0,0,1,2.13-1.3c3.9-.47,13.57,2.16,14,2.27a.5.5,0,0,1,.36.56,15.87,15.87,0,0,0,1.31,8.29.49.49,0,0,1-.22.67A.46.46,0,0,1,222.58,184.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.61,160.9l-.18,0c-2.64-1-4.68-1.62-4.7-1.63a.51.51,0,0,1-.35-.42,14.37,14.37,0,0,0-.86-3.48,6.81,6.81,0,0,0-2.16-2.47.51.51,0,0,1-.14-.7.5.5,0,0,1,.69-.13,7.63,7.63,0,0,1,2.52,2.91,14.24,14.24,0,0,1,.9,3.44c.67.21,2.38.78,4.45,1.54a.5.5,0,0,1,.3.64A.52.52,0,0,1,212.61,160.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,174.84a.48.48,0,0,1-.46-.32c0-.05-2.18-5.54-5.66-8.36-2.09-1.7-7.36-3.82-11.41-5.29a.5.5,0,0,1,.35-.94c4.12,1.5,9.49,3.66,11.7,5.45,3.67,3,5.86,8.55,6,8.78a.5.5,0,0,1-.29.65A.57.57,0,0,1,230,174.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.17,159h-.08l-2.94-.45a.51.51,0,0,1-.42-.57.51.51,0,0,1,.57-.42l2.94.45a.5.5,0,0,1-.07,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.49,172.83a.5.5,0,0,1,0-1c3.74,0,9.32-.43,10-1.37,1-1.35-.07-5.42-1-7.18-.49-1-3.54-.64-6.49-.32-1.35.15-2.75.31-4.12.37-4.22.2-4.27,2.42-4.27,2.44a.5.5,0,0,1-1,0c0-.13.06-3.19,5.22-3.44,1.34-.06,2.72-.21,4.06-.36,3.74-.41,6.69-.74,7.5.87s2.22,6.3.86,8.2C240.08,172.74,232.08,172.83,230.49,172.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.13,154.51a.5.5,0,0,1-.44-.25,11.78,11.78,0,0,0-3.24-3.45,15.32,15.32,0,0,0-3.49-2,.5.5,0,0,1-.32-.64.5.5,0,0,1,.63-.31A16.1,16.1,0,0,1,219,150a12.57,12.57,0,0,1,3.54,3.78.49.49,0,0,1-.19.68A.53.53,0,0,1,222.13,154.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7,138.69h-.1a.51.51,0,0,1-.39-.59c0-.06,1.09-5.6,0-10s-1.8-7-1.81-7a.49.49,0,0,1,.12-.47,37,37,0,0,0,5.12-7.12c1.78-3.57,4.71-9.87,4.74-9.93a.48.48,0,0,1,.34-.28c.09,0,9.77-2.28,14.68-3.61A46.47,46.47,0,0,0,204.9,94.8a.49.49,0,0,1,.74.27,21.75,21.75,0,0,0,2.63,5.5.5.5,0,1,1-.79.61,20.64,20.64,0,0,1-2.59-5.2,44.91,44.91,0,0,1-10.22,4.7c-4.49,1.23-13,3.21-14.48,3.57-.54,1.15-3.05,6.54-4.65,9.74a36.49,36.49,0,0,1-5.09,7.15c.2.76.82,3.1,1.74,6.75,1.14,4.58.05,10.16,0,10.39A.51.51,0,0,1,171.7,138.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,122.86l-.12,0a13.43,13.43,0,0,1-4.18-1.9.5.5,0,1,1,.55-.83,12.73,12.73,0,0,0,3.88,1.76.5.5,0,0,1,.35.61A.49.49,0,0,1,190.92,122.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.61,119.17a.46.46,0,0,1-.34-.15,17.58,17.58,0,0,1-3.06-3.89.5.5,0,0,1,.88-.47,17,17,0,0,0,2.87,3.65.48.48,0,0,1,0,.7A.52.52,0,0,1,184.61,119.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.09,87a.5.5,0,0,1-.5-.48,19.39,19.39,0,0,1,1.25-8.71.51.51,0,0,1,.67-.25.5.5,0,0,1,.24.67,18.38,18.38,0,0,0-1.16,8.25.5.5,0,0,1-.48.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.84,93.24a.49.49,0,0,1-.48-.4s-.22-1-.43-2.49a.51.51,0,0,1,.43-.56.5.5,0,0,1,.57.43c.19,1.45.4,2.4.4,2.41a.5.5,0,0,1-.38.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,104.32h-.09a.5.5,0,0,1-.4-.58c.51-2.92-5.74-9-8.2-11.06a.52.52,0,0,1-.06-.71.51.51,0,0,1,.71-.06c.95.81,9.24,8,8.53,12A.49.49,0,0,1,179.84,104.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,120.14a.48.48,0,0,1-.45-.29c-1.86-4.12-4.82-4-4.94-4a.51.51,0,0,1-.53-.47.49.49,0,0,1,.46-.53c.16,0,3.77-.2,5.92,4.59a.5.5,0,0,1-.25.66A.52.52,0,0,1,168.08,120.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.09 89.66 245.37 82.94 238.65 76.22 195.61 118.94 158.01 160.7 162.81 165.5 167.6 170.29 209.37 132.7 252.09 89.66",
    style: {
      fill: "#25B09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6,170.79a.49.49,0,0,1-.35-.15l-9.59-9.59a.49.49,0,0,1,0-.68l37.59-41.77,43.06-42.74a.51.51,0,0,1,.71,0L252.44,89.3a.51.51,0,0,1,0,.71l-42.72,43-41.78,37.61A.5.5,0,0,1,167.6,170.79Zm-8.9-10.11,8.92,8.92L209,132.32l42.35-42.66L238.64,76.92,196,119.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,68c18-18.7,32.4-34.35,32.4-34.35l-6-6-6-6S279,36.06,260.33,54s-25.92,25.43-25.92,25.43l7.22,7.22,7.21,7.21S256.3,86.68,274.27,68Z",
    style: {
      fill: "#25B09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84,94.39a.47.47,0,0,1-.35-.15L234.06,79.82a.5.5,0,0,1,0-.7c.08-.08,7.44-7.67,25.93-25.45s34.21-32.26,34.37-32.4a.5.5,0,0,1,.69,0l12,12a.51.51,0,0,1,0,.7c-.14.15-14.63,15.86-32.4,34.36h0c-17.77,18.49-25.37,25.86-25.44,25.93A.54.54,0,0,1,248.84,94.39ZM235.12,79.46l13.72,13.73c1.68-1.65,9.43-9.29,25.07-25.57,16.29-17,29.82-31.56,32.06-34l-11.3-11.3c-2.43,2.24-17,15.78-34,32.06C244.4,70,236.76,77.78,235.12,79.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,87.25a.46.46,0,0,1-.34-.15.48.48,0,0,1,0-.7L254,82.47a.5.5,0,1,1,.72.7l-3.84,3.92A.52.52,0,0,1,250.55,87.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,80a.49.49,0,0,1-.35-.14.5.5,0,0,1,0-.71l44.86-45.89a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.71L258,79.85A.51.51,0,0,1,257.63,80Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,113.81a.45.45,0,0,1-.34-.14.48.48,0,0,1,0-.7l20-20.6a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.7l-20,20.6A.48.48,0,0,1,224,113.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.48,77.37l-2.07,2.09,14.43,14.43s.67-.65,2.09-2.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84,94.39a.47.47,0,0,1-.35-.15L234.06,79.82a.5.5,0,0,1,0-.7s.66-.68,2.07-2.1a.47.47,0,0,1,.35-.15h0a.52.52,0,0,1,.35.14l14.46,14.46a.54.54,0,0,1,.14.36.5.5,0,0,1-.14.35l-2.1,2.07A.54.54,0,0,1,248.84,94.39ZM235.12,79.46l13.72,13.73,1.39-1.36L236.48,78.08C235.84,78.72,235.39,79.17,235.12,79.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.87,
    y: 164.29,
    width: 11.22,
    height: 5.93,
    transform: "translate(165.27 -64.49) rotate(45)",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.35,173.82a.5.5,0,0,1-.35-.14l-7.94-7.94a.5.5,0,0,1,0-.7l4.2-4.2a.5.5,0,0,1,.7,0l7.94,7.94a.5.5,0,0,1,0,.7l-4.2,4.2A.52.52,0,0,1,162.35,173.82Zm-7.23-8.43,7.23,7.22,3.48-3.48-7.22-7.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.42 165.39 148.98 175.59 151.47 178.08 162.35 173.32 154.42 165.39",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.47,178.58a.47.47,0,0,1-.35-.15l-2.5-2.49a.5.5,0,0,1-.08-.59l5.44-10.2a.47.47,0,0,1,.36-.25.46.46,0,0,1,.43.14L162.7,173a.48.48,0,0,1,.14.44.5.5,0,0,1-.29.37l-10.88,4.76A.45.45,0,0,1,151.47,178.58Zm-1.88-3.08,2,2,9.9-4.33-6.94-6.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.49 176.3 148.07 179.13 150.8 177.61 149.49 176.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.07,179.63a.5.5,0,0,1-.45-.73l1.42-2.83a.5.5,0,0,1,.8-.13l1.31,1.32a.48.48,0,0,1,.15.42.53.53,0,0,1-.26.37l-2.73,1.52A.5.5,0,0,1,148.07,179.63Zm1.55-2.49-.38.77.74-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.3,23.77h6.45a3.55,3.55,0,0,1,3.55,3.55v1.25a0,0,0,0,1,0,0H295.76a0,0,0,0,1,0,0V27.32A3.55,3.55,0,0,1,299.3,23.77Z",
    transform: "translate(107.12 -206.26) rotate(45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.63,33.16a.52.52,0,0,1-.36-.14l-9.58-9.59a.48.48,0,0,1,0-.7l.89-.89a4,4,0,0,1,5.72,0l4.57,4.56a4.07,4.07,0,0,1,0,5.73L306,33A.52.52,0,0,1,305.63,33.16Zm-8.88-10.08L305.63,32l.53-.54a3.05,3.05,0,0,0,0-4.31h0l-4.57-4.56a3,3,0,0,0-4.31,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,22.72l-2.67-1.22L240.12,67.84s1.09,1.09,1.7,1,5.34-2.18,7.52-4.85,1.82-4.25,3.64-5.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.73,69.32a3.56,3.56,0,0,1-2-1.13.48.48,0,0,1-.15-.36.49.49,0,0,1,.17-.36l50.94-46.34a.5.5,0,0,1,.55-.08l2.66,1.21a.49.49,0,0,1,.29.38.5.5,0,0,1-.16.45s-38.94,33.85-40.76,35.42a6,6,0,0,0-1.59,2.41,13.14,13.14,0,0,1-2,3.35c-2.25,2.75-7.06,4.88-7.81,5Zm-.86-1.48a2,2,0,0,0,.86.48c.45-.09,5.12-2.11,7.22-4.68a12.05,12.05,0,0,0,1.86-3.13,6.8,6.8,0,0,1,1.84-2.75l40.17-34.91-1.66-.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.22,109.3S219.33,119,204,122.43s-21.58,4.69-23.77,6.57-11.88,12.2-16.57,17.51-7.82,11.88.31,17.82,12.82,2.82,24.71-1.25,15.94-10.63,15.94-10.63,7.51-6.88,21.27-5.63,18.76,4.38,39.4,9.7a49.45,49.45,0,0,0,42.52-8.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.75,168.12c-2.91,0-5.72-.94-9.06-3.38-3.13-2.29-4.87-4.87-5.18-7.67-.35-3.28,1.21-6.84,4.79-10.89,4.84-5.49,14.43-15.68,16.62-17.56s7.27-2.94,19.83-5.74l4.15-.93c15.1-3.39,36.9-13,37.12-13.11a.5.5,0,0,1,.4.92c-.22.1-22.11,9.75-37.3,13.16l-4.15.93c-12,2.69-17.52,3.92-19.4,5.53-2.12,1.82-11.81,12.12-16.52,17.46-3.38,3.83-4.87,7.14-4.54,10.12.27,2.51,1.88,4.86,4.77,7,6.79,5,11.09,3.4,19.68.3,1.4-.51,2.91-1,4.57-1.62,11.54-4,15.64-10.36,15.68-10.42a.31.31,0,0,1,.09-.11c.31-.28,7.82-7,21.64-5.75,8.88.8,14.18,2.4,22.21,4.82,4.4,1.33,9.88,3,17.27,4.88a48.84,48.84,0,0,0,42.1-8,.5.5,0,1,1,.6.8A49.82,49.82,0,0,1,265.17,157c-7.41-1.91-12.9-3.56-17.31-4.89-8-2.4-13.23-4-22-4.79-12.83-1.16-20.19,4.9-20.83,5.46-.48.74-4.75,6.87-16.17,10.78-1.65.56-3.16,1.11-4.55,1.61C179.66,166.85,176.14,168.12,172.75,168.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.38,139.77s.9,10.63,2.94,13.57a10.74,10.74,0,0,0,4.29,3.84s-2.93,5.43-7.23,6.78-9.27-1.35-10.63-4.29a11.57,11.57,0,0,1-.45-7.69C161.75,150.85,172.38,139.77,172.38,139.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,164.83c-3.75,0-7.44-2.29-8.67-5a12,12,0,0,1-.46-8.09c.46-1.16,9.39-10.51,11.18-12.37a.49.49,0,0,1,.53-.12.5.5,0,0,1,.33.43c0,.1.91,10.52,2.85,13.32a10.46,10.46,0,0,0,4.07,3.67.52.52,0,0,1,.29.29.53.53,0,0,1,0,.41c-.12.23-3.08,5.62-7.52,7A8.33,8.33,0,0,1,170,164.83Zm2-23.93c-4.07,4.26-9.89,10.5-10.23,11.27a11.09,11.09,0,0,0,.45,7.29c1.31,2.84,6.07,5.27,10,4,3.34-1.06,5.88-4.8,6.68-6.1a12.15,12.15,0,0,1-4-3.77C173.19,151.15,172.28,143.73,172,140.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,141.74a46.68,46.68,0,0,1-2.53-9.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,142.24a.51.51,0,0,1-.47-.32,48.72,48.72,0,0,1-2.56-9.81.51.51,0,0,1,.43-.56.5.5,0,0,1,.56.43,47.13,47.13,0,0,0,2.5,9.58.48.48,0,0,1-.28.64A.39.39,0,0,1,183.77,142.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,148.68a22.62,22.62,0,0,1-2.42-3.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,149.18a.5.5,0,0,1-.4-.19,24.08,24.08,0,0,1-2.47-3.93.5.5,0,0,1,.9-.45,21.81,21.81,0,0,0,2.36,3.76.5.5,0,0,1-.08.7A.45.45,0,0,1,187.56,149.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.23,138.37a24.73,24.73,0,0,1,2.66,6.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.89,145.52a.49.49,0,0,1-.49-.4,24,24,0,0,0-2.6-6.49.5.5,0,0,1,.86-.52,25.08,25.08,0,0,1,2.72,6.81.5.5,0,0,1-.39.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-1--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.16,469.74l4.16-22.35,9.25-54s-3.23-19.51-5.83-27.19-6.19-20-3.42-29.54,31.56-31.37,40-39.34,21-12.36,28.19-9.1,8.3,14.52,10.44,17.49,12.42,8,13.15,7.43,4.86-9.73,6.46-20.46,2-12.09,4.27-15.75,7.76-4.46,7.76-4.46,6.47-1.42,7.76,6.38-.4,17.49-3.86,30.78-9.94,30.84-11.28,33.35-9.82,26.61-14.91,34-20.12,16-21.25,17.94-8,23.52-9.62,31.34-1.55,38.22-1.55,38.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.16,470.24h-.09a.48.48,0,0,1-.4-.58l4.15-22.35,9.24-53.95c-.23-1.4-3.32-19.73-5.8-27-2.79-8.25-6.19-20.32-3.42-29.84,2.11-7.26,18.59-21.16,30.63-31.31,4-3.35,7.41-6.25,9.54-8.25,8.94-8.41,21.57-12.45,28.74-9.19,5.21,2.36,7.31,8.66,8.84,13.25a19.76,19.76,0,0,0,1.79,4.39c2,2.79,11.14,7.21,12.49,7.28.77-1,4.67-9.64,6.22-20.08,1.59-10.69,2-12.18,4.35-15.94s7.88-4.66,8.11-4.69a7.11,7.11,0,0,1,5.1,1c1.7,1.14,2.78,3.09,3.23,5.77,1.35,8.17-.57,18.29-3.87,31-3.4,13-9.93,30.85-11.33,33.46-.37.7-1.37,3.28-2.65,6.56-3.23,8.29-8.63,22.17-12.29,27.46-3.33,4.82-10.61,10-15.93,13.78-2.54,1.81-4.95,3.52-5.29,4.13-1.16,2-8,23.49-9.57,31.19s-1.54,37.82-1.54,38.12a.5.5,0,0,1-.5.5h0a.5.5,0,0,1-.5-.5c0-1.24,0-30.53,1.56-38.32s8.51-29.46,9.68-31.49c.44-.76,2.21-2.05,5.58-4.44,5-3.53,12.46-8.87,15.69-13.53,3.59-5.21,9-19,12.18-27.26,1.34-3.44,2.3-5.92,2.7-6.67,1.38-2.59,7.86-20.25,11.24-33.25,3.27-12.56,5.17-22.57,3.85-30.57a7.28,7.28,0,0,0-2.79-5.1,6.25,6.25,0,0,0-4.37-.87c-.09,0-5.31.82-7.44,4.24-2.26,3.6-2.65,5.06-4.21,15.56s-5.63,19.95-6.63,20.77a1,1,0,0,1-.75.14c-2.19-.28-11.12-4.9-13.13-7.67a19.84,19.84,0,0,1-1.92-4.66c-1.48-4.42-3.5-10.48-8.31-12.66-6.83-3.1-19,.86-27.64,9-2.15,2-5.6,4.92-9.59,8.29-11.26,9.5-28.28,23.85-30.31,30.82-2.69,9.25.66,21.12,3.41,29.24,2.59,7.63,5.82,27.07,5.85,27.27a.43.43,0,0,1,0,.16l-9.25,54-4.16,22.36A.51.51,0,0,1,82.16,470.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57,358.62s6.43.88,8.48.59,3.21-1.17,6.72,1.17,7.89,6.43,12,5.55,8.48-1.75,12.57-6.72h0s.29,4.09,4.09,4.38,14.61-17.24,11.69-24l-2.92-6.72s6.13,6.13,9.93,6.13-.58-19-.88-21.62-12.27-9.94-16.07-13.15-15.2-3.8-19.58-.88-20.16,36.82-22.5,41.79-7.6,10.81-3.51,13.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.58,366.55c-3.12,0-6.23-2.26-9-4.29-.72-.52-1.41-1-2.07-1.47-2.73-1.82-3.88-1.58-5.35-1.27-.33.06-.66.13-1,.18-2.09.3-8.35-.54-8.62-.58a.68.68,0,0,1-.2-.07c-3.5-2.25-1.06-6.39,1.29-10.39.73-1.23,1.48-2.5,2-3.69l.36-.78c8.21-17.49,18.75-38.84,22.31-41.22,4.5-3,16.19-2.46,20.18.92,1.2,1,3.28,2.47,5.48,4,6.18,4.36,10.56,7.59,10.77,9.45.05.47.25,1.53.5,2.88,1.47,7.92,2.88,16.55,1.07,18.73a1.52,1.52,0,0,1-1.19.57c-2.7,0-6.38-2.8-8.53-4.66l2,4.55c1.91,4.4-1.71,13.31-6.08,19.46-1.43,2-4.14,5.38-6.11,5.2a4.85,4.85,0,0,1-4.36-3.77c-3.95,4.34-8.2,5.25-12,6.06l-.18,0A6.25,6.25,0,0,1,138.58,366.55Zm-14.9-8.25a7.86,7.86,0,0,1,4.37,1.66c.67.45,1.37,1,2.1,1.49,3,2.18,6.4,4.66,9.5,4l.18,0c4-.86,8.18-1.75,12.1-6.51h0l1.82-2.21a.49.49,0,0,1,.7-.06.5.5,0,0,1,.07.7l-1.68,2a4,4,0,0,0,3.61,3.73c.81.05,2.63-1.15,5.21-4.78,4.28-6,7.68-14.56,6-18.48l-2.92-6.72a.5.5,0,0,1,.17-.62.51.51,0,0,1,.64.06c.06.06,6,6,9.58,6a.51.51,0,0,0,.42-.21c1.67-2-.4-13.15-1.28-17.91-.27-1.42-.46-2.44-.51-2.95-.18-1.56-6.3-5.88-10.36-8.74-2.21-1.56-4.31-3-5.54-4.08-3.67-3.11-14.84-3.6-19-.84-1.53,1-6.41,7.67-22,40.8l-.37.78c-.58,1.24-1.34,2.53-2.07,3.78-2.57,4.36-4.08,7.35-1.71,9,.86.12,6.42.83,8.23.57.34,0,.65-.11,1-.17A8.11,8.11,0,0,1,123.68,358.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44,399.88a.47.47,0,0,1-.31-.12.49.49,0,0,1-.07-.7l3.07-3.74.77.64-3.07,3.73A.51.51,0,0,1,147.44,399.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,413c-5.44,0-11.37-3-11.67-3.12a.5.5,0,0,1,.45-.89c.09,0,9.06,4.52,14.65,2.47,3.67-1.35,9.42-5.46,13.58-8.84a.5.5,0,1,1,.63.77c-2,1.67-9.1,7.25-13.87,9A11,11,0,0,1,126,413Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.38,390.53h0a.51.51,0,0,1-.45-.55,11.59,11.59,0,0,0-.15-3.29.51.51,0,0,1,.41-.58.5.5,0,0,1,.58.41,13.14,13.14,0,0,1,.16,3.56A.51.51,0,0,1,148.38,390.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51,384.33A.49.49,0,0,1,147,384a38.47,38.47,0,0,0-6.56-11.13.5.5,0,1,1,.75-.66A38.61,38.61,0,0,1,148,383.67a.51.51,0,0,1-.32.63A.41.41,0,0,1,147.51,384.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,335.27a7.7,7.7,0,0,1-7.3-3.6l-75.52-125c-1.61-2.58-.13-5.45,2.45-7.06s5.28-1.32,6.89,1.25l79.26,122.71a7.69,7.69,0,0,1-2.47,10.6A7.6,7.6,0,0,1,205.61,335.27Z",
    style: {
      fill: "#25B09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.84,335.81a8.15,8.15,0,0,1-7-3.88l-75.53-125a4.67,4.67,0,0,1-.38-4.34,7.27,7.27,0,0,1,3-3.4,6.08,6.08,0,0,1,4.15-1,4.94,4.94,0,0,1,3.42,2.42l79.26,122.7a8.21,8.21,0,0,1-6.15,12.5C205.38,335.79,205.11,335.81,204.84,335.81ZM128.37,199.09a5.44,5.44,0,0,0-2.86.92,6.28,6.28,0,0,0-2.6,2.92,3.7,3.7,0,0,0,.3,3.45l75.53,125a7.15,7.15,0,0,0,6.82,3.36h0a7.2,7.2,0,0,0,5.41-11L131.71,201.11a4,4,0,0,0-2.74-2A3.86,3.86,0,0,0,128.37,199.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,347.35l-5.1-22.54-.07.05a4,4,0,0,0-.24-.46c-1.66-2.77-5.94-3.25-9.55-1.08s-5.18,6.18-3.51,8.95a4.72,4.72,0,0,0,1.72,1.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,347.85a.51.51,0,0,1-.31-.11l-16.75-13.42a5.17,5.17,0,0,1-1.84-1.79,5.73,5.73,0,0,1-.26-5.14,9.82,9.82,0,0,1,9.76-5.88,5.73,5.73,0,0,1,4.42,2.63c.06.1.11.2.16.3a.45.45,0,0,1,.21.26l5.1,22.54a.51.51,0,0,1-.23.53A.5.5,0,0,1,217.18,347.85Zm-10.3-25.39a8.64,8.64,0,0,0-4.4,1.29,8.42,8.42,0,0,0-3.53,4,4.75,4.75,0,0,0,.19,4.26,4.14,4.14,0,0,0,1.54,1.48l15.69,12.57-4.72-20.87a.4.4,0,0,1-.1-.12c-.06-.14-.13-.28-.2-.41a4.78,4.78,0,0,0-3.68-2.16C207.41,322.48,207.15,322.46,206.88,322.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,347.35,214,333.83a4.64,4.64,0,0,0-4.52.5,5.56,5.56,0,0,0-2.85,4.23Z",
    style: {
      fill: "#25B09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,347.85a.47.47,0,0,1-.32-.12l-10.52-8.79a.51.51,0,0,1-.18-.42,6.11,6.11,0,0,1,3.09-4.62,5.14,5.14,0,0,1,5-.53.53.53,0,0,1,.3.35l3.14,13.51a.51.51,0,0,1-.48.62Zm-10-9.51,9.17,7.66-2.75-11.8a4.19,4.19,0,0,0-3.84.56A5.21,5.21,0,0,0,207.18,338.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.62,285.07s7-8.77,7.6-9.78,11.91-16.86,14.36-18.52,8-1,8-1,22,13.3,23.3,14.6,5.95,4.88,7.69,8,12,15.47,11.21,19.83-7.34,7.61-11.93,6.87-10.65-6.8-12.6-9.7-4.41-6.23-4.41-6.23l-6.45-2.7-3.43-1.09s-8.13-7.76-17.11-4.74A143.34,143.34,0,0,1,129.62,285.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.17,305.69a8.17,8.17,0,0,1-1.42-.11c-4.68-.75-10.82-6.76-12.93-9.91-1.73-2.57-3.88-5.5-4.32-6.1l-6.32-2.65-3.4-1.07a.44.44,0,0,1-.19-.12c-.08-.07-8-7.51-16.6-4.63a149.23,149.23,0,0,1-16.27,4.46.52.52,0,0,1-.53-.23.53.53,0,0,1,0-.58c2.41-3,7.09-8.94,7.57-9.72.7-1.16,11.93-16.93,14.5-18.68s8.09-1.13,8.32-1.1a.48.48,0,0,1,.2.07c2.26,1.36,22.08,13.37,23.39,14.67.3.29.76.7,1.32,1.19,2,1.77,5.07,4.45,6.45,7,.46.83,1.56,2.37,2.84,4.15,3.81,5.32,9,12.62,8.43,16C201.51,302.52,195.78,305.69,191.17,305.69Zm-28-20.76,3.33,1.06L173,288.7a.56.56,0,0,1,.21.16s2.49,3.37,4.43,6.25,7.92,8.79,12.26,9.49,10.64-2.39,11.35-6.47c.53-3-5-10.66-8.26-15.25-1.35-1.88-2.41-3.37-2.89-4.25-1.3-2.36-4.39-5.08-6.24-6.7-.58-.51-1.05-.93-1.36-1.23-1-1-16.94-10.73-23.11-14.47-.76-.07-5.45-.47-7.54.95-2.3,1.56-13.45,17.11-14.21,18.37-.5.82-4.87,6.34-6.77,8.74a151.33,151.33,0,0,0,14.79-4.14C154.43,277.2,162.24,284.05,163.19,284.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.36,300.58a14.34,14.34,0,0,1-6.55-2.06,9.91,9.91,0,0,1-5.55-8.25.5.5,0,0,1,.08-.26,22.94,22.94,0,0,1,3.93-4.52c2.84-2.6,5.09-1.53,5.18-1.49a.5.5,0,1,1-.44.9c-.08,0-1.76-.78-4.06,1.32a24.08,24.08,0,0,0-3.68,4.19,9,9,0,0,0,5,7.23c5.77,3.08,7.77,1.67,8.11,1.36a.5.5,0,0,1,.68.74A4,4,0,0,1,197.36,300.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.17,279.29a.36.36,0,0,1-.14,0,.5.5,0,0,1-.34-.62c.77-2.65,5-4.29,5.14-4.36a.49.49,0,0,1,.64.28.5.5,0,0,1-.28.65s-3.9,1.53-4.54,3.71A.49.49,0,0,1,179.17,279.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.6,278.38a.5.5,0,0,1-.19-1l3-1.24a.5.5,0,0,1,.65.27.49.49,0,0,1-.27.65l-3,1.24A.41.41,0,0,1,183.6,278.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,263.06a.54.54,0,0,1-.22-.05.5.5,0,0,1-.23-.67c1.65-3.38,5.8-5,6-5.08a.5.5,0,0,1,.64.28.51.51,0,0,1-.28.65s-4,1.56-5.44,4.59A.5.5,0,0,1,153.1,263.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5,261.92a.5.5,0,0,1-.18-1,12.58,12.58,0,0,0,3.65-2.16.48.48,0,0,1,.7,0,.49.49,0,0,1,0,.7,13.19,13.19,0,0,1-4,2.39A.39.39,0,0,1,157.5,261.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8,306.42s-1.55-6,.16-10.48,20.39-10.32,20.39-10.32,17.79-7.68,24.79-9.08,15.23,9.92,15.23,9.92,15.76,17.72,18.24,23.66,1.54,10.79,1.48,12.69,1.73,7.92,1.77,10.77-3.57,4.86-7.57,5.25-7-3.12-8.89-5.78-5.57-13.25-5.57-13.25l-8.29-9.41-5.1-3.54-4.1-.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.66,339.37c-3.8,0-6.61-3.19-8.66-6-1.87-2.59-5.22-12.16-5.61-13.28l-8.19-9.29-4.95-3.44-4-.54-42.47.13h0a.51.51,0,0,1-.49-.38c-.06-.25-1.56-6.24.18-10.78s19.94-10.37,20.71-10.61,17.87-7.71,24.84-9.1c7.23-1.44,15.39,9.65,15.74,10.12.61.69,15.81,17.81,18.3,23.75a24.06,24.06,0,0,1,1.59,11.82c0,.43-.07.79-.08,1.09a28.58,28.58,0,0,0,.77,4.58,37.88,37.88,0,0,1,1,6.16c0,3.26-4,5.37-8,5.76C180.11,339.35,179.89,339.37,179.66,339.37ZM148.34,305.8l4.16.55a.43.43,0,0,1,.22.09l5.1,3.54a.24.24,0,0,1,.09.08l8.29,9.41a.42.42,0,0,1,.1.17c0,.1,3.65,10.54,5.51,13.11,2,2.79,4.79,6,8.43,5.59,3.48-.34,7.16-2.13,7.12-4.76a38.38,38.38,0,0,0-1-6,28.91,28.91,0,0,1-.79-4.81c0-.31,0-.69.08-1.14a23,23,0,0,0-1.52-11.35c-2.42-5.79-18-23.34-18.15-23.51s-8.16-11.09-14.77-9.77c-6.86,1.37-24.51,9-24.68,9.05-5.19,1.63-18.8,6.58-20.12,10-1.39,3.62-.53,8.43-.24,9.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.36,287.54l-.12,0a.5.5,0,0,1-.37-.6c1.74-7.26,5.8-8.47,6-8.52a.5.5,0,0,1,.61.35.49.49,0,0,1-.34.61c-.05,0-3.69,1.16-5.28,7.79A.49.49,0,0,1,148.36,287.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.49,284.56a.5.5,0,0,1-.35-.86,28.32,28.32,0,0,0,2.67-3.51.5.5,0,1,1,.83.55,28.62,28.62,0,0,1-2.8,3.68A.54.54,0,0,1,154.49,284.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.44,307.35a.59.59,0,0,1-.26-.07,9.86,9.86,0,0,1-4.46-7.1.5.5,0,0,1,.44-.55.5.5,0,0,1,.55.45,9,9,0,0,0,4,6.34.5.5,0,0,1,.18.68A.51.51,0,0,1,152.44,307.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,336.71a.49.49,0,0,1-.37-.16,4.75,4.75,0,0,1-.33-6.07.45.45,0,0,1,.2-.16,34.5,34.5,0,0,0,3.78-2,19.12,19.12,0,0,0,3.76-3.82.5.5,0,0,1,.7-.1.51.51,0,0,1,.1.7,19.77,19.77,0,0,1-4,4.07,34.37,34.37,0,0,1-3.78,2,3.78,3.78,0,0,0,.33,4.71.48.48,0,0,1,0,.7A.46.46,0,0,1,177.9,336.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07,329.39l19.1,3.41,3.67-.36,2.38,0s3.45,5.48,5,7.44,6.61,8.08,5.79,10.54,2.34,7.7,5.05,11.14,7.18.35,7.92-2.89,2-3.9,3.83-6.72,2.58-6.07,1.21-12-13.66-26.15-16.69-30.09S150,304.22,134,304.73s-29.64-.27-29.64-.27-7.59.74-9.93,6.52-4,19.16-4,19.16-4.15,4.58-4.73,9.63a59.71,59.71,0,0,0-.56,6.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,363.6a4.11,4.11,0,0,1-3.26-1.69c-.65-.82-6.3-8.12-5.14-11.61.66-2-3.58-7.36-5.18-9.4l-.53-.67c-1.35-1.76-4.16-6.18-4.84-7.26l-2.11,0-3.61.35h-.13L117,329.88a.5.5,0,0,1-.4-.58.51.51,0,0,1,.58-.41l19,3.41,3.6-.35,2.44,0a.52.52,0,0,1,.42.23c0,.05,3.44,5.48,4.93,7.41l.52.67c3.2,4.07,6.07,8.15,5.34,10.33s2.09,7,5,10.67a3,3,0,0,0,3.2,1.23,5.53,5.53,0,0,0,3.83-3.92,10.8,10.8,0,0,1,2.42-4.82c.44-.58.94-1.23,1.48-2.07,1.47-2.25,2.62-5.21,1.14-11.62-1.35-5.86-13.67-26.1-16.6-29.9s-4.2-5.46-19.92-5c-15.91.52-29.54-.26-29.68-.27s-7.24.79-9.44,6.21c-2.29,5.65-3.89,18.9-3.91,19a.52.52,0,0,1-.13.28s-4,4.52-4.61,9.35c-.11,1-.18,1.5-.22,1.82-.07.56-.07.56-.13,1.61,0,.59-.1,1.51-.2,3a.5.5,0,0,1-.54.46.49.49,0,0,1-.46-.53c.1-1.52.16-2.43.2-3,.07-1.09.07-1.09.14-1.67,0-.33.11-.83.22-1.82.55-4.75,4.08-9,4.76-9.79.19-1.58,1.72-13.62,4-19.12,2.43-6,10-6.8,10.35-6.84s13.81.79,29.67.27c16.23-.51,17.63,1.3,20.69,5.27s15.42,24.25,16.83,30.36c1.27,5.48.9,9.07-1.27,12.4-.56.87-1.08,1.54-1.53,2.13a9.94,9.94,0,0,0-2.24,4.43,6.48,6.48,0,0,1-4.58,4.67A3.85,3.85,0,0,1,160.89,363.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,362.53a.52.52,0,0,1-.35-.14c-1.75-1.68-1.1-5-1.07-5.13a.53.53,0,0,1,.25-.34.48.48,0,0,1,.42,0,16.72,16.72,0,0,0,3.52.8,3.31,3.31,0,0,0,2.91-1.52.5.5,0,0,1,.69-.17.51.51,0,0,1,.17.69,4.23,4.23,0,0,1-3.89,2A19.24,19.24,0,0,1,159,358c-.09.91-.12,2.69.86,3.64a.49.49,0,0,1,0,.7A.48.48,0,0,1,159.5,362.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.69,317.1a.46.46,0,0,1-.23-.06.5.5,0,0,1-.21-.67c.14-.28,3.5-6.66,6.27-8.4a.49.49,0,0,1,.69.16.51.51,0,0,1-.16.69c-2.54,1.59-5.88,7.94-5.92,8A.49.49,0,0,1,142.69,317.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.14,316.42a.47.47,0,0,1-.39-.19.5.5,0,0,1,.09-.7,18.31,18.31,0,0,0,3.45-4.48.5.5,0,0,1,.88.49,19.31,19.31,0,0,1-3.72,4.78A.5.5,0,0,1,147.14,316.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,350.31a.5.5,0,0,1,0-1,8.37,8.37,0,0,0,5.06-3,.5.5,0,0,1,.78.64,9.17,9.17,0,0,1-5.74,3.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,361.18s8.19,2.63,13.12-1a41.78,41.78,0,0,0,6.82-6s6.49,1.48,8.3,1l1.81-.44,7.24,3.79s-1.42,4.37,1.14,6.23,9.11,1.22,13-2.33,5.1-10,4.11-12-7.37-7.74-11-12.15-5.85-5.77-8.81-6.27-19.6-3.11-20.41-3.29-2.17-.58-2.17-.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.89,366.33a7.47,7.47,0,0,1-4.32-1.11c-2.36-1.72-1.73-5.18-1.43-6.38l-6.72-3.51-1.62.4c-1.7.42-6.84-.66-8.24-1a45.87,45.87,0,0,1-6.7,5.8c-5.08,3.77-13.22,1.2-13.57,1.09A.49.49,0,0,1,97,361a.5.5,0,0,1,.63-.32c.08,0,8,2.51,12.67-.94a43,43,0,0,0,6.73-5.87.47.47,0,0,1,.49-.17c1.78.4,6.68,1.38,8.07,1l1.81-.44a.47.47,0,0,1,.35,0l7.24,3.78a.51.51,0,0,1,.25.6s-1.28,4.05.95,5.68c2.42,1.75,8.73,1,12.36-2.3s4.88-9.65,4-11.44c-.5-1-2.69-3.27-5-5.65-2-2-4.25-4.38-5.91-6.4-3.71-4.54-5.85-5.65-8.5-6.1-1.29-.22-5.19-.84-9.23-1.48-6.49-1-10.77-1.72-11.21-1.82-.82-.18-2.15-.57-2.2-.58a.5.5,0,0,1-.34-.62.49.49,0,0,1,.62-.34s1.34.39,2.14.57c.44.1,6.13,1,11.14,1.8l9.24,1.48c3.29.57,5.68,2.25,9.12,6.46,1.62,2,3.87,4.3,5.85,6.33,2.47,2.54,4.6,4.74,5.18,5.91,1.14,2.33-.32,9.05-4.22,12.62A14.34,14.34,0,0,1,139.89,366.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.07,354.83c-3.09,0-8.37-.61-10.67-4.43a.48.48,0,0,1,.17-.68.49.49,0,0,1,.68.17c3,4.9,12,3.83,12.07,3.82a.5.5,0,1,1,.12,1A20.85,20.85,0,0,1,115.07,354.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.15,357.93A16.09,16.09,0,0,1,103,356a.49.49,0,0,1-.18-.68.5.5,0,0,1,.68-.19c.06,0,6.52,3.64,11.42.44a.5.5,0,1,1,.54.83A9.44,9.44,0,0,1,110.15,357.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8,361.1a5.17,5.17,0,0,1-4.5-2.26.5.5,0,1,1,.86-.51c.07.11,1.49,2.43,5.19,1.59a.5.5,0,1,1,.22,1A7.85,7.85,0,0,1,138.8,361.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.73,347h0a.5.5,0,0,1-.5-.5,48.93,48.93,0,0,1,.41-5.57c.43-3.32,1.9-4.06,2.07-4.14a.5.5,0,0,1,.42.91s-1.14.65-1.5,3.36a49.06,49.06,0,0,0-.4,5.44A.5.5,0,0,1,133.73,347Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.78,343.69l-.13,0a.5.5,0,0,1-.35-.62l.88-3.17a.5.5,0,0,1,.61-.35.49.49,0,0,1,.35.61l-.88,3.18A.5.5,0,0,1,135.78,343.69Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.2b2984b3ee560f5cbf177739847c27f0.svg";
export { ForwardRef as ReactComponent };